import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, Fragment as _Fragment, createElementBlock as _createElementBlock, renderList as _renderList } from "vue";
var _hoisted_1 = {
  key: 0
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_svg_icon = _resolveComponent("svg-icon");
  var _component_el_badge = _resolveComponent("el-badge");
  var _component_el_menu_item = _resolveComponent("el-menu-item");
  var _component_router_link = _resolveComponent("router-link");
  var _component_sidebar_item = _resolveComponent("sidebar-item", true);
  var _component_el_sub_menu = _resolveComponent("el-sub-menu");
  return !$props.item.hidden ? (_openBlock(), _createElementBlock("div", _hoisted_1, [$options.hasOneShowingChild($props.item.children, $props.item) && (!_ctx.onlyOneChild.children || _ctx.onlyOneChild.noShowingChildren) && !$props.item.alwaysShow ? (_openBlock(), _createElementBlock(_Fragment, {
    key: 0
  }, [_ctx.onlyOneChild.meta ? (_openBlock(), _createBlock(_component_router_link, {
    key: 0,
    to: $options.resolvePath(_ctx.onlyOneChild.path)
  }, {
    default: _withCtx(function () {
      return [_createVNode(_component_el_menu_item, {
        index: $options.resolvePath(_ctx.onlyOneChild.path),
        class: _normalizeClass({
          'submenu-title-noDropdown': !$props.isNest
        }),
        onClick: $options.clickitem
      }, {
        default: _withCtx(function () {
          return [_createVNode(_component_svg_icon, {
            "icon-class": _ctx.$route.path == $options.resolvePath(_ctx.onlyOneChild.path) ? _ctx.onlyOneChild.meta.select_icon || '' : _ctx.onlyOneChild.meta.icon || $props.item.meta && $props.item.meta.icon || ''
          }, null, 8, ["icon-class"]), _createVNode(_component_el_badge, {
            value: "新增",
            color: 'red',
            hidden: $options.isSubMenuHiddenBadge($props.item),
            offset: [10, 15]
          }, {
            default: _withCtx(function () {
              return [_createTextVNode(_toDisplayString($props.item.meta ? $props.item.meta.title : ''), 1)];
            }),
            _: 1
          }, 8, ["hidden"]), $props.item.meta.subIcon ? (_openBlock(), _createBlock(_component_svg_icon, {
            key: 0,
            class: "sub-icon",
            "icon-class": $props.item.meta.subIcon
          }, null, 8, ["icon-class"])) : _createCommentVNode("", true)];
        }),
        _: 1
      }, 8, ["index", "class", "onClick"])];
    }),
    _: 1
  }, 8, ["to"])) : _createCommentVNode("", true)], 64)) : $options.parentHasAccess($props.item) ? (_openBlock(), _createBlock(_component_el_sub_menu, {
    key: 1,
    ref: "subMenu",
    index: $options.resolvePath($props.item.path),
    "popper-append-to-body": ""
  }, {
    title: _withCtx(function () {
      return [_createVNode(_component_svg_icon, {
        "icon-class": $props.item.meta ? $props.item.meta.icon || '' : ''
      }, null, 8, ["icon-class"]), _createVNode(_component_el_badge, {
        "is-dot": "",
        color: 'red',
        hidden: $options.isRootMenuHiddenBadge($props.item),
        offset: [8, 20]
      }, {
        default: _withCtx(function () {
          return [_createTextVNode(_toDisplayString($props.item.meta.title), 1)];
        }),
        _: 1
      }, 8, ["hidden"])];
    }),
    default: _withCtx(function () {
      return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.item.children, function (child) {
        return _openBlock(), _createBlock(_component_sidebar_item, {
          key: child.path,
          "is-nest": true,
          item: child,
          "base-path": $options.resolvePath(child.path),
          class: "nest-menu"
        }, null, 8, ["item", "base-path"]);
      }), 128))];
    }),
    _: 1
  }, 8, ["index"])) : _createCommentVNode("", true)])) : _createCommentVNode("", true);
}